import { render, staticRenderFns } from "./WordTableListP.vue?vue&type=template&id=66fc3cd3&scoped=true&"
import script from "./WordTableListP.vue?vue&type=script&lang=js&"
export * from "./WordTableListP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fc3cd3",
  null
  
)

export default component.exports